/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RequestsRefreshTokenDtoRefreshTokenDto } from '../../models/requests-refresh-token-dto-refresh-token-dto';

export interface AdminControllerRefresh$Params {
      body: RequestsRefreshTokenDtoRefreshTokenDto
}

export function adminControllerRefresh(http: HttpClient, rootUrl: string, params: AdminControllerRefresh$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * 액세스 토큰
 */
'accessToken'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, adminControllerRefresh.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      
      /**
       * 액세스 토큰
       */
      'accessToken'?: string;
      }>;
    })
  );
}

adminControllerRefresh.PATH = '/api/admin/refresh';
